import React from 'react';
import { Phone } from 'lucide-react';
import { businessInfo } from '../data/mock';

const StickyCallBar = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-amber-500 shadow-lg border-t border-amber-600">
      <a
        href={businessInfo.phoneLink}
        className="flex items-center justify-center gap-3 py-4 px-6 text-slate-900 font-bold text-lg hover:bg-amber-400 transition-colors active:bg-amber-600"
      >
        <Phone className="w-6 h-6 animate-pulse" />
        <span>Call {businessInfo.phone}</span>
      </a>
    </div>
  );
};

export default StickyCallBar;
